import { apiClient } from '../../client'
import { PaginatedResponse } from '../role.repository'

export interface NpdBatch {
  id: number
  tenant_id: number
  client_id: number
  client_name?: string
  en_name: string
  ar_name: string
  start_date: string
  end_date: string
  status: number
  guideline_attachment?: string | null
  is_primary_guideline?: number
  primary_guideline_description?: string | null
  is_secondary_guideline?: number
  secondary_guideline_description?: string | null
  is_other_guidelines?: number
  other_guidelines_description?: string | null
  created_by?: string | number
  updated_by?: string | number
  created_at?: string
  updated_at?: string
  store_count?: number
  sku_count?: number
}

export interface CreateNpdBatchRequest {
  client_id: number
  en_name: string
  ar_name?: string
  start_date: string
  end_date: string
  status?: number
  guideline_attachment?: string | null
  is_primary_guideline?: number
  primary_guideline_description?: string | null
  is_secondary_guideline?: number
  secondary_guideline_description?: string | null
  is_other_guidelines?: number
  other_guidelines_description?: string | null
}

export interface UpdateNpdBatchRequest {
  client_id?: number
  en_name?: string
  ar_name?: string
  start_date?: string
  end_date?: string
  status?: number
  guideline_attachment?: string | null
  is_primary_guideline?: number
  primary_guideline_description?: string | null
  is_secondary_guideline?: number
  secondary_guideline_description?: string | null
  is_other_guidelines?: number
  other_guidelines_description?: string | null
}

class NpdBatchRepository {
  async getAll(
    page: number = 1,
    limit: number = 10,
    filters?: { search?: string; status?: string; client_id?: string },
  ): Promise<PaginatedResponse<NpdBatch>> {
    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit),
    })

    if (filters?.search?.trim()) params.append('search', filters.search.trim())
    if (filters?.status?.trim()) params.append('status', filters.status.trim())
    if (filters?.client_id?.trim()) params.append('client_id', filters.client_id.trim())

    return apiClient.get<PaginatedResponse<NpdBatch>>(`/npd-batch?${params.toString()}`)
  }

  async getOne(id: number): Promise<NpdBatch> {
    return apiClient.get<NpdBatch>(`/npd-batch/${id}`)
  }

  async create(data: CreateNpdBatchRequest): Promise<NpdBatch> {
    return apiClient.post<NpdBatch>('/npd-batch', data)
  }

  async update(id: number, data: UpdateNpdBatchRequest): Promise<NpdBatch> {
    return apiClient.put<NpdBatch>(`/npd-batch/${id}`, data)
  }

  async remove(id: number): Promise<{ message: string }> {
    return apiClient.delete<{ message: string }>(`/npd-batch/${id}`)
  }
}

export const npdBatchRepository = new NpdBatchRepository()
